import React, { useState } from 'react'
import './Testimonial.css'
import {testimonialsData} from "../../data/testimonialsData"
import leftarrow from "../../assets/leftArrow.png"
import{motion} from "framer-motion"


const Testimonial = () => {
  const [selected, setSelected] = useState(0);
  const tLength = testimonialsData.length;
  const transition = {type: 'spring', duration: 3}

  return (
    <div className='testimonials'id='Testimonials'>
        <div className='left-t'>
            <span>Testimonials</span>
            <span className='stroke-text'>what they</span>
            <span>say about us</span>
            <motion.span
                key={selected}
                initial={{opacity: 0, x: -100}}
                transition={{...transition, duration: 2}}
                whileInView={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 100}}>
                {testimonialsData[selected].review}
            </motion.span>
            <span>
                <span style={{color: 'var(--orange)'}}>
                    {testimonialsData[selected].name}
                </span>{" "}
                -{testimonialsData[selected].status}
            </span>
        </div>
        <div className='right-t'>
            <motion.div
            initial={{opacity: 0, x: -100}}
            transition={{...transition, duration: 3}}
            whileInView={{opacity: 1, x: 0}}
            ></motion.div>

            <motion.div
            initial={{opacity: 0, x: 100}}
            transition={{...transition, duration: 3}}
            whileInView={{opacity: 1, x: 0}}
            ></motion.div>

            <motion.img 
            key={selected}
            initial={{opacity: 0, x: 100}}
            transition={{...transition, duration: 2}} 
            whileInView={{opacity: 1, x: 0}}
            exit={{opacity: 0, x: -100}}
            src={testimonialsData[selected].image} alt='testimonial' />
            <div className='arrows'>
                <img onClick={() => 
                    selected === 0 
                     ? setSelected(tLength -1) 
                     :setSelected((selected) => selected -1)}
                src={leftarrow} alt='left-arrow' /> 

                <img
                    onClick={()=>
                        selected ===tLength -1?
                        setSelected(0)
                        :setSelected((selected) => selected +1)}
  
                src={leftarrow}
                 alt='right-arrow' />
            </div>
        </div>
    </div>
  )
}

export default Testimonial